<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{modalTitle}}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form [formGroup]="formGroup">

            <app-input-date-time formControlName="date">
                <label>{{ 'dialogs.productSubscription.endDialogDateLabel' | translate }}</label>
            </app-input-date-time>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-beenden" mat-flat-button
                color="accent"
                (click)="saveAndContinue()"
                class="save-button"
                [disabled]="isSaving"
                [attr.aria-label]="'dialogs.productSubscription.endDialogSubmit' | translate">
            {{ 'dialogs.productSubscription.endDialogSubmit' | translate }}
        </button>

    </div>
</div>
